// extracted by mini-css-extract-plugin
export default {"cls1":"ResearchInterestTags-cls1__c520aeab07e08aa0e2dd","cls2":"ResearchInterestTags-cls2___1df954c5e0a68ef5bce ResearchInterestTags-cls1__c520aeab07e08aa0e2dd"};